export default __webpack_public_path__ + "static/media/explore6.9c2f4b49.png";